import { useContext } from 'react';

import { LscStateContext } from './LscContextProvider';

import LscData from './LscData';

const useLscData = (isCurrent) => {
  const [lscState, setLscState] = useContext(LscStateContext);
  const getLscs = () => { LscData.getLscs(lscState, setLscState, isCurrent); }

  return {
    lscState,
    getLscs
  };
};

export default useLscData;